import React from 'react';

const CarouselLeftArrow = () => {
  const inlineStyles = {
    root: {
      cursor: 'pointer',
      transition: 'all 0.2s ease',
    },
    background: {
      fill: '#FBF9F7',
      transition: 'fill 0.2s ease',
    },
    arrow: {
      fill: '#162C55',
      transition: 'fill 0.2s ease',
    },
  };

  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={inlineStyles.root}
      onMouseEnter={e => {
        const rect = e.currentTarget.querySelector('rect');
        const path = e.currentTarget.querySelector('path');
        if (rect) rect.style.fill = '#162C55';
        if (path) path.style.fill = 'white';
      }}
      onMouseLeave={e => {
        const rect = e.currentTarget.querySelector('rect');
        const path = e.currentTarget.querySelector('path');
        if (rect) rect.style.fill = '#FBF9F7';
        if (path) path.style.fill = '#162C55';
      }}
    >
      <rect width="56" height="56" rx="28" style={inlineStyles.background} />
      <path
        d="M21.0275 27.5224L27.5275 21.0224C27.7875 20.7624 28.2175 20.7624 28.4875 21.0224C28.7475 21.2824 28.7475 21.7124 28.4875 21.9824L23.1375 27.3324H34.5075C34.8775 27.3324 35.1775 27.6324 35.1775 28.0024C35.1775 28.3724 34.8775 28.6724 34.5075 28.6724H23.1375L28.4775 34.0124C28.7375 34.2724 28.7375 34.7024 28.4775 34.9724C28.3475 35.1024 28.1775 35.1724 27.9975 35.1724C27.8175 35.1724 27.6475 35.1024 27.5175 34.9724L21.0175 28.4724C20.7575 28.2124 20.7575 27.7824 21.0175 27.5124L21.0275 27.5224Z"
        style={inlineStyles.arrow}
      />
    </svg>
  );
};

export default CarouselLeftArrow;
